module.exports = __webpack_public_path__ + "6cc29904a79a3b504e5ffd34126c5aee.jpg";